
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexyeU4MnAPvqHEXxVB6_MEDSxB_45rEFyKdW_2VHp7ScndYMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/index.vue?macro=true";
import { default as indexS8Xkun_ig3M_45_45ZC_0vk4HbJjgMcZ_45e0ZnbvPaEfQkQsMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/login/index.vue?macro=true";
import { default as set_45workspaceIXMzPEdYrJ7zkoyD4N6wsonv9ybHKwcp_I9p_45agtMDQMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/set-workspace.vue?macro=true";
import { default as indexy3_orUidQj1ERhqASjhiwzK2W70Nsqdl4ixRYQJTdS0Meta } from "/codebuild/output/src213701036/src/zazos-web/pages/sign-up/index.vue?macro=true";
import { default as indexb_ICiPGeyAyOYKtDoqp4MC3mdIWsKlGh3kaK0HorqzoMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/magic-link/index.vue?macro=true";
import { default as indexxB5ZSAvX5CGNx7ZzcEgMFeQZrhonlnQxStvSamFRnuoMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/index.vue?macro=true";
import { default as index_45tp_45yqL_bg8eR2tJ3ZoX0xm23Qb_q2iqeoRIaEwpziwMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue?macro=true";
import { default as newPmsncS6T9YXtr_45eCVdb6t8cZHcF8ja39MQvA056mWZkMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue?macro=true";
import { default as account_45configuration3eRNI85fTEgSSECTl_Kz7rVvh5zQg5eHAhNHsZFfoFIMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue?macro=true";
import { default as indexGo_451YxIQa3p5g1ZURcxwY2SCajTFkSd7eGQdIpTaGe0Meta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue?macro=true";
import { default as mHdjK51hdzic5LF6gsi5xMYXgwUPpOzIW0gR0oBRjZAQMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m.vue?macro=true";
import { default as index0IsqFvZ9pcgygxtoYt0XPrg6_FIW_45RQ_swAKVBjqFL0Meta } from "/codebuild/output/src213701036/src/zazos-web/pages/reset-password/index.vue?macro=true";
import { default as indexQs_45r5Fg7doauQwYPeXNYpqWr6kxUOew0MnXtB0phaRoMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/index.vue?macro=true";
import { default as indexW4gFWN_SAoByIJ56V6ppmtRR_pf0sk1o_45iF6oB7mFBQMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue?macro=true";
import { default as index7TkzTPtZ4PokWqxh5FDW6WMiez65kp9QzmjF6_45ZJKXEMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue?macro=true";
import { default as user_45signupdFTTJSWO0xTtf5gobO8xfUd_PchLKotP5x79S_QbxeQMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue?macro=true";
import { default as indextWpdMM_45PkIhpBrJ1FB_HZGjNTcGRwSgDHq0crIBexrwMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue?macro=true";
import { default as index87EZU25oDUVHsgkh7IQ2o4SvHdovNpZo8lUKFSRVTbEMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue?macro=true";
import { default as indexM17RIW_45gEyMH_s8fA9me28_MYaLma8RLxo4YTzHKi_450Meta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue?macro=true";
import { default as newwAabtXt9K5Iv0dvPF1ovd3Yku8k_3XjW5oWWDMzRW2cMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue?macro=true";
import { default as _91id_93B6GxC_kmCOeSZetiM23_45Q3_62uagcv0R3fJzieAHLUgMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue?macro=true";
import { default as index77c2xOfN8vK2vlXVIkYtWY8ZYqaB8qk6zK8h576gLCsMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue?macro=true";
import { default as indexUS7uG2dod8ZIXXbS1wAupJ2QUisO_45DjAb2nDQbqWYn0Meta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue?macro=true";
import { default as indexCBXYv5orzY7OCSwo_UoCAlAxK_456ecW3B25WXr21tE1YMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue?macro=true";
import { default as indexfex92Is7dKui5HoJ7_8ab_w_45K1WogQeXiYRJ_fa2Fy8Meta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue?macro=true";
import { default as indexrX2_uho9VR1uFkEF2iQLQseUh18zEeV6oLqGtT15wIoMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue?macro=true";
import { default as indexeRO2MF_OgpWcMYrf5PuQFL4ANcNxXLC8rY78NvK1m0YMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue?macro=true";
import { default as indexT91mmCw2EaGNgsO8S8BsSpxkgyikthqimpg_45g3s1tUoMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue?macro=true";
import { default as _91providerSlug_93jQ5Xu_jMtl0KwbFmoUZ0aMffSXc1EhwQ7ZlIHsEf_45UoMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue?macro=true";
import { default as indexywedpzOmHTyqp4VScI6t0RepFMvIkf0M8Gd4bMSTJIEMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue?macro=true";
import { default as settingsKUI6G2biotcVz5JVrK0UNCNjdZIj6sawiZPRVMqS9asMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue?macro=true";
import { default as indexeEUjya_45XIe25WoDWDPjWtKD9J0_DAOVC1PONAC7a0a0Meta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue?macro=true";
import { default as _91id_93kMFlxQtydGTDdak_w_TLg_kN7byQGaaS7Krm7jWZJo8Meta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue?macro=true";
import { default as indexOQWj_JPII3NVIlhR89tJ73ZPp02WCT7kkt5SVmVNpqQMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue?macro=true";
import { default as index3iiJddq2Hev0PjOgOvqZ_UAtCASp4yMmZ2JTRi0WOMwMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue?macro=true";
import { default as importQ3rQD9vx3ln5N_45hPxsCNYftGCMWcyrqg_2ZaZsxVyr8Meta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue?macro=true";
import { default as schema9IHc1LDcW9yHKuoQuPG7xC6QLjbzdphPiSacq5zYQ6oMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue?macro=true";
import { default as index6PodOS6p5l1fUvMid1jv4YPQf_GhymUUT1fM3yTPLE8Meta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue?macro=true";
import { default as indexDQSv52Y1k2eSRLqwH_2k_VQLyfgbQBoXY_wSmEiyfUkMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue?macro=true";
import { default as historyCnle1djXcfyqiCiIpews2h2oqyr_S_bw5dnOO_8ks8AMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue?macro=true";
import { default as studio89MCHCk53lkbUaRxdtUr8k2nkdZugEW9Zi0CosxdeXAMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio.vue?macro=true";
import { default as indexu5fTsfDN7QcJBZrTt03JXcnol9UVBfdyQp7gmM3Rxb0Meta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/p/index.vue?macro=true";
import { default as index5vyfDUrOxEgRmP5YeuQzrQjqvUFZSszjx5E4qjv_45dUsMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue?macro=true";
import { default as indexjnB6_alTSCkqgEygF0_45dbFQnhkwtKZ_451mP0chMyuuRgMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/login/index.vue?macro=true";
import { default as indexhG4_45rTU2UaS4lVwiBwDipe0U_45gEA8b5M1BsEaZvwugwMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/store/index.vue?macro=true";
import { default as _91app_93zC4eJF5eOIoz99DdCANK6vqm6MvrWivatS859q981AMMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue?macro=true";
import { default as indexNx_6GtY4R73xXnO0ArI9m5p9azZ46G_45OAszvOQR7_CAMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue?macro=true";
import { default as indexczvPlitnSok7AVr2dI_S5SXB0YOctiJOZ5LUFwgTd08Meta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue?macro=true";
import { default as reset_45passwordSDecwBIYLZh0CxlDBDO__stGIgRveEWEMU0djBY_4571sMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue?macro=true";
import { default as indexW4Q5_qFF9Bkw_45vM5RtSdgYOkKxPY2GkXJZHUNZ0_izUMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue?macro=true";
import { default as indexceLGME6tVRvj5AtpPb5zIsHk_45lA5fd2mRWOKCJUA0awMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue?macro=true";
import { default as indexprj_45Gt37O8lQowLZ9lAXbhUpDiQsz42iRL7uIlz_45IXoMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue?macro=true";
import { default as _91appName_93xojmfdD2csAme91h_45BrOJFQ8Q1tQh0jIqivw8NKxFhsMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue?macro=true";
import { default as indexR8oNl_45DH_45BN4PvS0_45MIyJue4zaKXQvNZluVj3x1yLesMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue?macro=true";
import { default as indexP3XHt67BDyaPaxRZEJOmMQ8S75wDfJZaQVtJ7OKpap0Meta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue?macro=true";
import { default as indexcyK5OnRkVtqmUrfU3qwzv43WbB0XQ6nZ1otiTQmIDMcMeta } from "/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/en",
    meta: indexyeU4MnAPvqHEXxVB6_MEDSxB_45rEFyKdW_2VHp7ScndYMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/",
    meta: indexyeU4MnAPvqHEXxVB6_MEDSxB_45rEFyKdW_2VHp7ScndYMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/login/index.vue")
  },
  {
    name: "login___pt",
    path: "/login",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/login/index.vue")
  },
  {
    name: "set-workspace___en",
    path: "/en/set-workspace",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/set-workspace.vue")
  },
  {
    name: "set-workspace___pt",
    path: "/set-workspace",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/set-workspace.vue")
  },
  {
    name: "sign-up___en",
    path: "/en/sign-up",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/sign-up/index.vue")
  },
  {
    name: "sign-up___pt",
    path: "/sign-up",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/sign-up/index.vue")
  },
  {
    name: "magic-link___en",
    path: "/en/magic-link",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/magic-link/index.vue")
  },
  {
    name: "magic-link___pt",
    path: "/magic-link",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/magic-link/index.vue")
  },
  {
    name: mHdjK51hdzic5LF6gsi5xMYXgwUPpOzIW0gR0oBRjZAQMeta?.name,
    path: "/en/t/:tenantSlug()/m",
    meta: mHdjK51hdzic5LF6gsi5xMYXgwUPpOzIW0gR0oBRjZAQMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m.vue"),
    children: [
  {
    name: "t-tenantSlug-m___en",
    path: "",
    meta: indexxB5ZSAvX5CGNx7ZzcEgMFeQZrhonlnQxStvSamFRnuoMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId___en",
    path: ":viewId()",
    meta: index_45tp_45yqL_bg8eR2tJ3ZoX0xm23Qb_q2iqeoRIaEwpziwMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-new___en",
    path: ":viewId()/r/new",
    meta: newPmsncS6T9YXtr_45eCVdb6t8cZHcF8ja39MQvA056mWZkMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue")
  },
  {
    name: "t-tenantSlug-m-account-configuration___en",
    path: "account-configuration",
    meta: account_45configuration3eRNI85fTEgSSECTl_Kz7rVvh5zQg5eHAhNHsZFfoFIMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-recordId___en",
    path: ":viewId()/r/:recordId()",
    meta: indexGo_451YxIQa3p5g1ZURcxwY2SCajTFkSd7eGQdIpTaGe0Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue")
  }
]
  },
  {
    name: mHdjK51hdzic5LF6gsi5xMYXgwUPpOzIW0gR0oBRjZAQMeta?.name,
    path: "/t/:tenantSlug()/m",
    meta: mHdjK51hdzic5LF6gsi5xMYXgwUPpOzIW0gR0oBRjZAQMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m.vue"),
    children: [
  {
    name: "t-tenantSlug-m___pt",
    path: "",
    meta: indexxB5ZSAvX5CGNx7ZzcEgMFeQZrhonlnQxStvSamFRnuoMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId___pt",
    path: ":viewId()",
    meta: index_45tp_45yqL_bg8eR2tJ3ZoX0xm23Qb_q2iqeoRIaEwpziwMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-new___pt",
    path: ":viewId()/r/new",
    meta: newPmsncS6T9YXtr_45eCVdb6t8cZHcF8ja39MQvA056mWZkMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue")
  },
  {
    name: "t-tenantSlug-m-account-configuration___pt",
    path: "account-configuration",
    meta: account_45configuration3eRNI85fTEgSSECTl_Kz7rVvh5zQg5eHAhNHsZFfoFIMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-recordId___pt",
    path: ":viewId()/r/:recordId()",
    meta: indexGo_451YxIQa3p5g1ZURcxwY2SCajTFkSd7eGQdIpTaGe0Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue")
  }
]
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/reset-password/index.vue")
  },
  {
    name: "reset-password___pt",
    path: "/reset-password",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/reset-password/index.vue")
  },
  {
    name: "t-tenantSlug___en",
    path: "/en/t/:tenantSlug()",
    meta: indexQs_45r5Fg7doauQwYPeXNYpqWr6kxUOew0MnXtB0phaRoMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/index.vue")
  },
  {
    name: "t-tenantSlug___pt",
    path: "/t/:tenantSlug()",
    meta: indexQs_45r5Fg7doauQwYPeXNYpqWr6kxUOew0MnXtB0phaRoMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/index.vue")
  },
  {
    name: studio89MCHCk53lkbUaRxdtUr8k2nkdZugEW9Zi0CosxdeXAMeta?.name,
    path: "/en/t/:tenantSlug()/studio",
    meta: studio89MCHCk53lkbUaRxdtUr8k2nkdZugEW9Zi0CosxdeXAMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio.vue"),
    children: [
  {
    name: "t-tenantSlug-studio___en",
    path: "",
    meta: indexW4gFWN_SAoByIJ56V6ppmtRR_pf0sk1o_45iF6oB7mFBQMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue")
  },
  {
    name: settingsKUI6G2biotcVz5JVrK0UNCNjdZIj6sawiZPRVMqS9asMeta?.name,
    path: "settings",
    meta: settingsKUI6G2biotcVz5JVrK0UNCNjdZIj6sawiZPRVMqS9asMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue"),
    children: [
  {
    name: "t-tenantSlug-studio-settings___en",
    path: "",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-signup___en",
    path: "user-signup",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-users___en",
    path: "users",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-tokens___en",
    path: "tokens",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-internal___en",
    path: "internal",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-new___en",
    path: "user-groups/new",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-id___en",
    path: "user-groups/:id()",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-app-builder___en",
    path: "app-builder",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-export-data___en",
    path: "export-data",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups___en",
    path: "user-groups",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations___en",
    path: "integrations",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-authentication___en",
    path: "authentication",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-email-analytics___en",
    path: "email-analytics",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-system-entities___en",
    path: "system-entities",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations-providerSlug___en",
    path: "integrations/:providerSlug()",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-global-parameters-manager___en",
    path: "global-parameters-manager",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue")
  }
]
  },
  {
    name: "t-tenantSlug-studio-data___en",
    path: "data",
    meta: indexeEUjya_45XIe25WoDWDPjWtKD9J0_DAOVC1PONAC7a0a0Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-pages-id___en",
    path: "pages/:id()",
    meta: _91id_93kMFlxQtydGTDdak_w_TLg_kN7byQGaaS7Krm7jWZJo8Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-pages___en",
    path: "pages",
    meta: indexOQWj_JPII3NVIlhR89tJ73ZPp02WCT7kkt5SVmVNpqQMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id___en",
    path: "data/:id()",
    meta: index3iiJddq2Hev0PjOgOvqZ_UAtCASp4yMmZ2JTRi0WOMwMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-import___en",
    path: "data/:id()/import",
    meta: importQ3rQD9vx3ln5N_45hPxsCNYftGCMWcyrqg_2ZaZsxVyr8Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-schema___en",
    path: "data/:id()/schema",
    meta: schema9IHc1LDcW9yHKuoQuPG7xC6QLjbzdphPiSacq5zYQ6oMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue")
  },
  {
    name: "t-tenantSlug-studio-automations___en",
    path: "automations",
    meta: index6PodOS6p5l1fUvMid1jv4YPQf_GhymUUT1fM3yTPLE8Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id___en",
    path: "automations/:id()",
    meta: indexDQSv52Y1k2eSRLqwH_2k_VQLyfgbQBoXY_wSmEiyfUkMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id-history___en",
    path: "automations/:id()/history",
    meta: historyCnle1djXcfyqiCiIpews2h2oqyr_S_bw5dnOO_8ks8AMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue")
  }
]
  },
  {
    name: studio89MCHCk53lkbUaRxdtUr8k2nkdZugEW9Zi0CosxdeXAMeta?.name,
    path: "/t/:tenantSlug()/studio",
    meta: studio89MCHCk53lkbUaRxdtUr8k2nkdZugEW9Zi0CosxdeXAMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio.vue"),
    children: [
  {
    name: "t-tenantSlug-studio___pt",
    path: "",
    meta: indexW4gFWN_SAoByIJ56V6ppmtRR_pf0sk1o_45iF6oB7mFBQMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue")
  },
  {
    name: settingsKUI6G2biotcVz5JVrK0UNCNjdZIj6sawiZPRVMqS9asMeta?.name,
    path: "settings",
    meta: settingsKUI6G2biotcVz5JVrK0UNCNjdZIj6sawiZPRVMqS9asMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue"),
    children: [
  {
    name: "t-tenantSlug-studio-settings___pt",
    path: "",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-signup___pt",
    path: "user-signup",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-users___pt",
    path: "users",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-tokens___pt",
    path: "tokens",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-internal___pt",
    path: "internal",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-new___pt",
    path: "user-groups/new",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-id___pt",
    path: "user-groups/:id()",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-app-builder___pt",
    path: "app-builder",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-export-data___pt",
    path: "export-data",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups___pt",
    path: "user-groups",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations___pt",
    path: "integrations",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-authentication___pt",
    path: "authentication",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-email-analytics___pt",
    path: "email-analytics",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-system-entities___pt",
    path: "system-entities",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations-providerSlug___pt",
    path: "integrations/:providerSlug()",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-global-parameters-manager___pt",
    path: "global-parameters-manager",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue")
  }
]
  },
  {
    name: "t-tenantSlug-studio-data___pt",
    path: "data",
    meta: indexeEUjya_45XIe25WoDWDPjWtKD9J0_DAOVC1PONAC7a0a0Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-pages-id___pt",
    path: "pages/:id()",
    meta: _91id_93kMFlxQtydGTDdak_w_TLg_kN7byQGaaS7Krm7jWZJo8Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-pages___pt",
    path: "pages",
    meta: indexOQWj_JPII3NVIlhR89tJ73ZPp02WCT7kkt5SVmVNpqQMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id___pt",
    path: "data/:id()",
    meta: index3iiJddq2Hev0PjOgOvqZ_UAtCASp4yMmZ2JTRi0WOMwMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-import___pt",
    path: "data/:id()/import",
    meta: importQ3rQD9vx3ln5N_45hPxsCNYftGCMWcyrqg_2ZaZsxVyr8Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-schema___pt",
    path: "data/:id()/schema",
    meta: schema9IHc1LDcW9yHKuoQuPG7xC6QLjbzdphPiSacq5zYQ6oMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue")
  },
  {
    name: "t-tenantSlug-studio-automations___pt",
    path: "automations",
    meta: index6PodOS6p5l1fUvMid1jv4YPQf_GhymUUT1fM3yTPLE8Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id___pt",
    path: "automations/:id()",
    meta: indexDQSv52Y1k2eSRLqwH_2k_VQLyfgbQBoXY_wSmEiyfUkMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id-history___pt",
    path: "automations/:id()/history",
    meta: historyCnle1djXcfyqiCiIpews2h2oqyr_S_bw5dnOO_8ks8AMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue")
  }
]
  },
  {
    name: "t-tenantSlug-p___en",
    path: "/en/t/:tenantSlug()/p",
    meta: indexu5fTsfDN7QcJBZrTt03JXcnol9UVBfdyQp7gmM3Rxb0Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/p/index.vue")
  },
  {
    name: "t-tenantSlug-p___pt",
    path: "/t/:tenantSlug()/p",
    meta: indexu5fTsfDN7QcJBZrTt03JXcnol9UVBfdyQp7gmM3Rxb0Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/p/index.vue")
  },
  {
    name: "t-tenantSlug-mfa___en",
    path: "/en/t/:tenantSlug()/mfa",
    meta: index5vyfDUrOxEgRmP5YeuQzrQjqvUFZSszjx5E4qjv_45dUsMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue")
  },
  {
    name: "t-tenantSlug-mfa___pt",
    path: "/t/:tenantSlug()/mfa",
    meta: index5vyfDUrOxEgRmP5YeuQzrQjqvUFZSszjx5E4qjv_45dUsMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue")
  },
  {
    name: "t-tenantSlug-login___en",
    path: "/en/t/:tenantSlug()/login",
    meta: indexjnB6_alTSCkqgEygF0_45dbFQnhkwtKZ_451mP0chMyuuRgMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/login/index.vue")
  },
  {
    name: "t-tenantSlug-login___pt",
    path: "/t/:tenantSlug()/login",
    meta: indexjnB6_alTSCkqgEygF0_45dbFQnhkwtKZ_451mP0chMyuuRgMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/login/index.vue")
  },
  {
    name: "t-tenantSlug-store___en",
    path: "/en/t/:tenantSlug()/store",
    meta: indexhG4_45rTU2UaS4lVwiBwDipe0U_45gEA8b5M1BsEaZvwugwMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/store/index.vue")
  },
  {
    name: "t-tenantSlug-store___pt",
    path: "/t/:tenantSlug()/store",
    meta: indexhG4_45rTU2UaS4lVwiBwDipe0U_45gEA8b5M1BsEaZvwugwMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/store/index.vue")
  },
  {
    name: "t-tenantSlug-install-app___en",
    path: "/en/t/:tenantSlug()/install/:app()",
    meta: _91app_93zC4eJF5eOIoz99DdCANK6vqm6MvrWivatS859q981AMMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue")
  },
  {
    name: "t-tenantSlug-install-app___pt",
    path: "/t/:tenantSlug()/install/:app()",
    meta: _91app_93zC4eJF5eOIoz99DdCANK6vqm6MvrWivatS859q981AMMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue")
  },
  {
    name: "t-tenantSlug-loading___en",
    path: "/en/t/:tenantSlug()/loading",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue")
  },
  {
    name: "t-tenantSlug-loading___pt",
    path: "/t/:tenantSlug()/loading",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue")
  },
  {
    name: "t-tenantSlug-sign-up___en",
    path: "/en/t/:tenantSlug()/sign-up",
    meta: indexczvPlitnSok7AVr2dI_S5SXB0YOctiJOZ5LUFwgTd08Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue")
  },
  {
    name: "t-tenantSlug-sign-up___pt",
    path: "/t/:tenantSlug()/sign-up",
    meta: indexczvPlitnSok7AVr2dI_S5SXB0YOctiJOZ5LUFwgTd08Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue")
  },
  {
    name: "t-tenantSlug-reset-password___en",
    path: "/en/t/:tenantSlug()/reset-password",
    meta: reset_45passwordSDecwBIYLZh0CxlDBDO__stGIgRveEWEMU0djBY_4571sMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue")
  },
  {
    name: "t-tenantSlug-reset-password___pt",
    path: "/t/:tenantSlug()/reset-password",
    meta: reset_45passwordSDecwBIYLZh0CxlDBDO__stGIgRveEWEMU0djBY_4571sMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue")
  },
  {
    name: "t-tenantSlug-sso-saml___en",
    path: "/en/t/:tenantSlug()/sso/saml",
    meta: indexW4Q5_qFF9Bkw_45vM5RtSdgYOkKxPY2GkXJZHUNZ0_izUMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue")
  },
  {
    name: "t-tenantSlug-sso-saml___pt",
    path: "/t/:tenantSlug()/sso/saml",
    meta: indexW4Q5_qFF9Bkw_45vM5RtSdgYOkKxPY2GkXJZHUNZ0_izUMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue")
  },
  {
    name: "t-tenantSlug-mfa-setup___en",
    path: "/en/t/:tenantSlug()/mfa/setup",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue")
  },
  {
    name: "t-tenantSlug-mfa-setup___pt",
    path: "/t/:tenantSlug()/mfa/setup",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId___en",
    path: "/en/t/:tenantSlug()/p/:viewId()",
    meta: indexprj_45Gt37O8lQowLZ9lAXbhUpDiQsz42iRL7uIlz_45IXoMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId___pt",
    path: "/t/:tenantSlug()/p/:viewId()",
    meta: indexprj_45Gt37O8lQowLZ9lAXbhUpDiQsz42iRL7uIlz_45IXoMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-store-apps-appName___en",
    path: "/en/t/:tenantSlug()/store/apps/:appName()",
    meta: _91appName_93xojmfdD2csAme91h_45BrOJFQ8Q1tQh0jIqivw8NKxFhsMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue")
  },
  {
    name: "t-tenantSlug-store-apps-appName___pt",
    path: "/t/:tenantSlug()/store/apps/:appName()",
    meta: _91appName_93xojmfdD2csAme91h_45BrOJFQ8Q1tQh0jIqivw8NKxFhsMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue")
  },
  {
    name: "t-tenantSlug-install--review___en",
    path: "/en/t/:tenantSlug()/install/-review",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue")
  },
  {
    name: "t-tenantSlug-install--review___pt",
    path: "/t/:tenantSlug()/install/-review",
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue")
  },
  {
    name: "t-tenantSlug-email-validation___en",
    path: "/en/t/:tenantSlug()/email-validation",
    meta: indexP3XHt67BDyaPaxRZEJOmMQ8S75wDfJZaQVtJ7OKpap0Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue")
  },
  {
    name: "t-tenantSlug-email-validation___pt",
    path: "/t/:tenantSlug()/email-validation",
    meta: indexP3XHt67BDyaPaxRZEJOmMQ8S75wDfJZaQVtJ7OKpap0Meta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId-r-recordId___en",
    path: "/en/t/:tenantSlug()/p/:viewId()/r/:recordId()",
    meta: indexcyK5OnRkVtqmUrfU3qwzv43WbB0XQ6nZ1otiTQmIDMcMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId-r-recordId___pt",
    path: "/t/:tenantSlug()/p/:viewId()/r/:recordId()",
    meta: indexcyK5OnRkVtqmUrfU3qwzv43WbB0XQ6nZ1otiTQmIDMcMeta || {},
    component: () => import("/codebuild/output/src213701036/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue")
  }
]